window['ossTemplateUrlProvider'] = function (url) {
    if (!url) return url;
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) return url;
    return contentPath + url;
};

window.appSettings = window.appSettings || {};
window.appSettings.serverUrl = window.serverUrl;

var widget = angular.module('oss-widget', [require('../app/app')]);

widget.factory('backToMain', require('./services/backToMainService'));
widget.config(require('./widget.config'));
widget.run(require('./widget.run'));

angular.element(document).ready(function () {
    setTimeout(function () {
        var appContainer = document.querySelector(".app__container");
        angular.bootstrap(appContainer, ['oss-widget'], { strictDi: true });
    }, 500);
});
